var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMaleIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.3487 0V1.33026H13.7292L8.61573 6.44444C7.54297 5.61096 6.19286 5.2177 4.84032 5.34474C3.48778 5.47178 2.23452 6.10957 1.33573 7.12823C0.436935 8.14689 -0.0397976 9.46983 0.0026041 10.8277C0.0450058 12.1855 0.603354 13.4761 1.56395 14.4367C2.52455 15.3973 3.81517 15.9557 5.173 15.9981C6.53083 16.0405 7.85377 15.5637 8.87244 14.6649C9.8911 13.7661 10.5289 12.5129 10.6559 11.1603C10.783 9.8078 10.3897 8.45769 9.55622 7.38493L14.6697 2.27075V6.6513H16V0H9.3487ZM5.35792 14.6329C4.56862 14.6329 3.79705 14.3988 3.14077 13.9603C2.48449 13.5218 1.97298 12.8985 1.67093 12.1693C1.36887 11.4401 1.28984 10.6376 1.44383 9.86351C1.59781 9.08938 1.9779 8.37829 2.53602 7.82017C3.09414 7.26205 3.80523 6.88196 4.57936 6.72798C5.3535 6.57399 6.15591 6.65302 6.88513 6.95508C7.61435 7.25713 8.23762 7.76864 8.67614 8.42492C9.11465 9.0812 9.3487 9.85277 9.3487 10.6421C9.34747 11.7001 8.92662 12.7145 8.17847 13.4626C7.43032 14.2108 6.41597 14.6316 5.35792 14.6329Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaleIcon);
export default __webpack_public_path__ + "static/media/maleIcon.d4d5818d1c77a748edc7512983d6a32c.svg";
export { ForwardRef as ReactComponent };